import {
    Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import store from '@/state/store';
import { campaignAPI } from '@samclick-static-urls';
import { sendGet, sendPut, sendPost } from '@samclick-api-client';
import Payload from './payload';
import { _filter } from '@/plugins/lodash';


class CampaignState {
    public loading: boolean = false

    public campaignList: object[] = []
}

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: 'campaign',
})
class CampaignStore extends VuexModule {
    campaignStore: CampaignState = new CampaignState();

    get campaign() {
        return _filter(this.campaignStore.campaignList, campaign => campaign.defaultCampaign !== 1);
    }

    @Mutation
    CAMPAIGN_REINITIALIZE() {
        this.campaignStore = new CampaignState();
    }

    @Mutation
    SET_CAMPAIGN_LOADING(loading: boolean) {
        this.campaignStore.loading = loading;
    }

  @Mutation
    SET_CAMPAIGN_SEARCH(response: object[]) {
        this.campaignStore.campaignList = response || [];
    }

    @Action({ rawError: true })
  showLoader(show: boolean) {
      this.context.commit('SET_CAMPAIGN_LOADING', show);
  }

    @Action({ rawError: true })
    destroyCampaign() {
        this.context.commit('CAMPAIGN_REINITIALIZE');
    }

  @Action({ rawError: true })
    getCampaignList(payload: Payload = new Payload()) {
        this.showLoader(payload.activateLoader);
        return new Promise((resolve, reject) => {
            sendGet(campaignAPI.campaignList, payload.data).then((response) => {
                if (payload.storeData) {
                    this.context.commit('SET_CAMPAIGN_SEARCH', response.data);
                }
                this.showLoader(false);
                resolve(response);
            }, (error) => {
                this.showLoader(false);
                reject(error.response);
            });
        });
    }

  @Action({ rawError: true })
  saveCampaignGroup(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendPost(campaignAPI.saveGroup, payload.data).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  saveCampaign(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendPost(campaignAPI.saveCampaign, payload.data).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }
}


export default getModule(CampaignStore);
